"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HammerThrowAbilityHandler = exports.HammerThrowActorAbilityFactory = exports.HammerThrowAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class HammerThrowAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HammerThrow;
        this.__typeName = "HammerThrow";
    }
}
exports.HammerThrowAbilityArgs = HammerThrowAbilityArgs;
let HammerThrowActorAbilityFactory = class HammerThrowActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HammerThrow", "AllEnemies", 2);
    }
};
HammerThrowActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HammerThrow")
], HammerThrowActorAbilityFactory);
exports.HammerThrowActorAbilityFactory = HammerThrowActorAbilityFactory;
let HammerThrowAbilityHandler = class HammerThrowAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyJumpingProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targetIds: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies),
            projectileType: "SunbreakerHammer",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 60)
            ],
        });
    }
};
HammerThrowAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HammerThrow)
], HammerThrowAbilityHandler);
exports.HammerThrowAbilityHandler = HammerThrowAbilityHandler;
